import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'
import type { GraphQLOutcomeOverrideSection } from '@/types/OutcomeOverride'

const overrideOutcomeMutation = gql`
  mutation overrideOutcome(
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $outcomeOverrides: [OverrideOutcomeSection!]!
    $userId: String
    $reason: String
  ) {
    overrideOutcome(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      outcomeOverrides: $outcomeOverrides
      userId: $userId
      reason: $reason
    )
  }
`

export type MutationVars = {
  customerId: string
  applicationId: string
  subjectId: string
  outcomeOverrides: GraphQLOutcomeOverrideSection[]
  userId: string
  reason?: string
}

export type OverrideOutcomeData = {
  overrideOutcome: string | unknown
}

export const useOverrideOutcomeMutation: WrappedMutation<
  OverrideOutcomeData,
  MutationVars
> = () =>
  useMutation<OverrideOutcomeData, MutationVars>(overrideOutcomeMutation, {
    client: agentClient,
  })
